module.exports = __webpack_public_path__ + "static/media/design.29a6017e.svg";